export default __webpack_public_path__ + "static/media/MENS_CACADORES.4c4b3537.png";